import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-31">
      <svg width="32" height="32" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0" data-id="element-32">
        <path d="M50 15L85 45H70L50 28L30 45H15L50 15Z" fill="url(#paint0_linear_dark)" data-id="element-33" />
        <path d="M50 35L85 65H70L50 48L30 65H15L50 35Z" fill="url(#paint1_linear_dark)" data-id="element-34" />
        <path d="M50 55L85 85H70L50 68L30 85H15L50 55Z" fill="url(#paint2_linear_dark)" data-id="element-35" />
        <defs data-id="element-36">
          <linearGradient id="paint0_linear_dark" x1="50" y1="15" x2="50" y2="45" gradientUnits="userSpaceOnUse" data-id="element-37">
            <stop stopColor="#0E1A35" data-id="element-38" />
            <stop offset="1" stopColor="#2A3A5C" data-id="element-39" />
          </linearGradient>
          <linearGradient id="paint1_linear_dark" x1="50" y1="35" x2="50" y2="65" gradientUnits="userSpaceOnUse" data-id="element-40">
            <stop stopColor="#0E1A35" data-id="element-41" />
            <stop offset="1" stopColor="#2A3A5C" data-id="element-42" />
          </linearGradient>
          <linearGradient id="paint2_linear_dark" x1="50" y1="55" x2="50" y2="85" gradientUnits="userSpaceOnUse" data-id="element-43">
            <stop stopColor="#0E1A35" data-id="element-44" />
            <stop offset="1" stopColor="#2A3A5C" data-id="element-45" />
          </linearGradient>
        </defs>
      </svg>
      <span className="font-display font-bold text-xl tracking-tight text-bg-primary" data-id="element-46">
        RIA Catalyst
      </span>
    </div>;
}